<header class="modal-header confirmar-correo-bg">
    <div class="modal-title text-center text-white h3 w-100 p-5">
      <img
            src="../../../../../assets/icons/interrogation-icon.png"
            class="d-inline-block img-responsive mr-3"
            alt=""
          />
      Atención
    </div>
  </header>
  <section class="modal-body text-center pl-5 pr-5 pb-5">
    <div [innerHTML]="mensaje"></div>
    
  </section>
  <div class="text-center">

    <footer class="modal-footer">
      <div class="row">
        <div class="col-6">
          <button class="btn btn-secundary w-100" (click)="activeModal.dismiss()">Cancelar</button>
        </div>
        <div class="col-6">
          <button class="btn btn-primary w-100" (click)="confirm()">Aceptar</button>
        </div>
      </div>
      
    </footer>
  </div>
  